import {
    createAsyncThunk,
    createSlice,
} from '@reduxjs/toolkit';

import {
    add,
    deleteRecord,
    fetch,
    fetchRecords,
    update,
} from '../services/MeteringRecordsService.ts';


import {
    deleteOneCase,
    fetchManyCase,
    fetchOneCase,
    saveOneCase,
    updateOneCase,
} from '../../../store/RecordsSliceCaseHelpers';
import {MeteringRecord} from '../types';

const entityKey = 'meteringRecords';

interface MeteringRecordsState {
    byId: { [key: string]: MeteringRecord },
    ids: string[],
    totalCount: number,
    loading: boolean,
    error: string
}

const initialState = {
    byId: {},
    ids: [],
    totalCount: 0,
    loading: false,
    error: '',
} as MeteringRecordsState;


const normalizeRecord = (record: MeteringRecord) => {
    return Object.assign({}, record);
};

// generates pending, fulfilled and rejected
export const fetchMeteringRecords = createAsyncThunk(
    `${entityKey}/fetchRecords`,
    () => {

        const filter = {}

        return fetchRecords(filter)
            .then((response) => {
                if (response) {
                    return response.map((record: MeteringRecord) => {
                        return normalizeRecord(record);
                    });
                }
            });
    },
);

export const fetchMeteringRecord = createAsyncThunk(
    `${entityKey}/fetch`,
    (id: string) => {
        return fetch(id)
            .then((response) => {
                if (typeof response !== 'undefined') {
                    return normalizeRecord(response);
                }
            });
    });

export const saveMeteringRecord = createAsyncThunk(
    `${entityKey}/add`,
    (payload: MeteringRecord) => {
        return add(payload)
            .then((response) => {
                if (response) {
                    return normalizeRecord(response);
                }
            });
    });

export const updateMeteringRecord = createAsyncThunk(
    `${entityKey}/update`,
    ({
         id,
         record,
     }: { id: string, record: MeteringRecord }) => {

        return update(id, record)
            .then((response) => {
                if (response) {
                    return normalizeRecord(response);
                }
            });
    },
);

export const deleteMeteringRecord = createAsyncThunk(
    `${entityKey}/deleteRecord`,
    (id: string) => {
        return deleteRecord(id)
            .then(() => id);
    },
);


export const storeMeteringRecord = createAsyncThunk(
    `${entityKey}/store`,
    (payload: MeteringRecord) => {
        return normalizeRecord(payload);
    },
);


const componentsSlice = createSlice({
                                        name: entityKey,
                                        initialState,
                                        reducers: {
                                            clearState: () => initialState,
                                        },
                                        extraReducers: (builder) => {
                                            // FETCH MANY
                                            fetchManyCase(builder, fetchMeteringRecords, entityKey);

                                            // FETCH ONE
                                            fetchOneCase(builder, fetchMeteringRecord);

                                            // SAVE ONE
                                            saveOneCase(builder, saveMeteringRecord);

                                            // UPDATE ONE
                                            updateOneCase(builder, updateMeteringRecord);

                                            updateOneCase(builder, storeMeteringRecord);

                                            // DELETE ONE
                                            deleteOneCase(builder, deleteMeteringRecord);
                                        },
                                    });

export default componentsSlice.reducer;
